import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {HeaderBalanceBox} from "./boxes/header-balance/header-balance.box";
import React from "react";
import styled from "styled-components";
import {observer} from 'mobx-react';
import { BalanceValue } from "../../balance-box/balance-value.component";

const SDKComponentInlineBox = styled.span`
    padding: 0 5px;
`;

export const MiniOrbitBalanceComponent = observer(class MiniOrbitBalanceComponent extends OrbitComponent<{}> {
    render() {
        if (!this.services.user.isAuthorized) {
            return null;
        }

        return <HeaderBalanceBox className={'cy-mini-orbit-balance'}>
            <span>{this.services.translation.translate('MINI_ORBIT_BALANCE')}</span>
            <SDKComponentInlineBox>
                <BalanceValue />
            </SDKComponentInlineBox>
        </HeaderBalanceBox>;
    }
});